module.exports = function() {
  return new Worker(__webpack_public_path__ + "f4eb16529286f9d9569c.worker.js");
};